// extracted by mini-css-extract-plugin
export default {"editorArea":"MarkdownEditor_editorArea__HThlL"};